module.exports = __webpack_public_path__ + "img/guizhouHints_20.4ac83d98.jpg";